/**
 * Le menu latéral des espaces, replié ou déplié : un choix de la personne, et
 * de ce navigateur seulement.
 *
 * ## Pourquoi il se replie
 *
 * Signalé le 9 octobre 2026 sur l'écran des factures : « il nous faut
 * toujours faire glisser pour voir la fin du tableau ». La page vit dans un
 * conteneur de 1 280 px dont le menu prend 240 ; il restait environ 980 px
 * à un tableau qui en demande un peu plus, et la colonne qui disparaissait
 * était la dernière — les actions. Replié, le menu ne garde que ses icônes
 * (56 px) et rend 184 px à la page, pour toutes les pages des espaces.
 *
 * ## Pourquoi le stockage du navigateur suffit
 *
 * C'est une commodité d'affichage, pas une donnée : la perdre (navigation
 * privée, stockage vidé ou refusé) ramène au menu déplié, et rien d'autre.
 * Chaque accès est donc protégé — un stockage qui lève ne doit pas empêcher
 * la page de s'afficher.
 */

/** La clé du choix dans le stockage du navigateur. */
export const CLE_MENU_REPLIE = 'cdv:espaces:menu-replie';

/** Le stockage du navigateur, ou `null` quand il est absent ou refusé. */
export function stockageLocal(): Pick<Storage, 'getItem' | 'setItem'> | null {
  try {
    return typeof window === 'undefined' ? null : window.localStorage;
  } catch {
    return null;
  }
}

/** Le menu était-il replié ? Déplié par défaut, et sur toute lecture impossible. */
export function lireMenuReplie(stockage: Pick<Storage, 'getItem'> | null): boolean {
  try {
    return stockage?.getItem(CLE_MENU_REPLIE) === '1';
  } catch {
    return false;
  }
}

/** Retenir le choix. Un stockage refusé n'est pas une erreur : le choix vaut pour la page ouverte. */
export function retenirMenuReplie(stockage: Pick<Storage, 'setItem'> | null, replie: boolean): void {
  try {
    stockage?.setItem(CLE_MENU_REPLIE, replie ? '1' : '0');
  } catch {
    /* Navigation privée ou quota : le menu reste tel quel jusqu'au rechargement. */
  }
}
